import styled from 'styled-components';

export const CustomerProfilingSegmentationSliderStyles = styled.div`
  width: 100%;
  margin-top: 100px !important;

  @media (max-width: 991px) {
    margin-top: 50px !important;
  }

  .sliderWrapper {
    margin-top: 50px;
  }

  .slide {
    max-width: 770px;
    height: 550px;
    width: 100%;
    /* border-radius: 10px 10px;
    border: 5px solid #AE19A4; */
    position: relative;
    background: #fff;
    flex-shrink: 0;

    @media (max-width: 768px) {
      max-width: 320px;
      height: 400px;
    }

    &-img {
      height: 50%;
      position: relative;

      border-radius: 10px 10px 0 0;
      border-left: 5px solid #AE19A4;
      border-right: 5px solid #AE19A4;
      border-top: 5px solid #AE19A4;
      overflow: hidden;

      @media (max-width: 768px) {
        height: 30%;
      }

      &::before {
        position: absolute;
        content: "";
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 2;

        background: linear-gradient(180deg, rgba(250, 61, 194, 0.24) 0%, rgba(174, 25, 164, 0.73) 100%);
        border-radius: 10px;
      }

      img {
        width: 100%;
        height: 100%;
        position: relative;
        object-fit: cover;
        z-index: 1;
      }
    }

    &-text {
      display: flex;
      flex-direction: column;
      padding: 30px;
      gap: 20px;
      height: calc(50% - 70px);

      border-radius: 0 0 10px 10px;
      border-left: 5px solid #AE19A4;
      border-right: 5px solid #AE19A4;
      border-bottom: 5px solid #AE19A4;

      @media (max-width: 768px) {
        padding: 10px 15px;
        gap: 10px;
        height: calc(70% - 70px);
      }

      h5 {
        font-weight: 600;
        font-size: 28px;
        line-height: 120%;
        color: #000;

        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      p {
        font-weight: 500;
        font-size: 20px;
        line-height: 115%;
        color: #000000;

        @media (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
  }

  .btn-wrapper {
    max-width: 1190px;
    margin: 50px auto 0;
  }
`;
